import type { AssetTypeTemplateFormEditorProps } from "./asset-type-template-form-editor.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import FormEditor from "@/components/FormEngine/Editor";
import { TAB_KEYS } from "@/constants/TabKeys";
import { AppSaveBar } from "@/modules/app-save-bar";

import { TECHNICAL_FORM_EDITOR_SCOPE } from "./asset-type-template-form-editor.constant";
import { useTemplateSchema } from "./asset-type-template-form-editor.hook";

export const AssetTypeTemplateFormEditor = ({
  template,
  loading,
}: AssetTypeTemplateFormEditorProps) => {
  const { t } = useTranslation();
  const { schema, onUpdate } = useTemplateSchema(template);

  return (
    <FormEditor
      loading={loading}
      schema={schema || {}}
      context="technical_form"
      onUpdateSchema={onUpdate}
      emptyDescription={
        <Typography.Text>{t("technicalForm:emptyForm")}</Typography.Text>
      }
      parentId={template?.id}
      syncTabNav
      tabBarExtraContent={
        <AppSaveBar
          scope={TECHNICAL_FORM_EDITOR_SCOPE}
          tabs={[TAB_KEYS.TEMPLATE_FORM_EDITOR, TAB_KEYS.TEMPLATE_SCHEMA]}
          date={template?.updated_at}
          loading={loading}
        />
      }
    />
  );
};
